import { Component, Input, OnInit } from '@angular/core';

import { TranslatePipe } from 'app/pipes/translate.pipe';

@Component({
  selector: 'ota-dialog-success',
  templateUrl: './dialog-success.component.html',
  styleUrls: ['./dialog-success.component.scss']
})
export class DialogSuccessComponent implements OnInit {
  @Input('text') text: string;
  @Input('icon') icon: String = `icon-successful`;

  constructor() {}

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal/dialog-success/dialog-success.component.ts